import { useTranslation } from '@pancakeswap/localization'
import { Flex, Text, useMatchBreakpoints } from '@pancakeswap/uikit'
import { useQuery } from '@tanstack/react-query'
import { ChainTags } from './ChainTags'
import { MetricsCard } from './MetricsCard'

const Stats = () => {
  const { t } = useTranslation()
  const { data: tvl = 0 } = useQuery<number>(['tvl'], { enabled: false })
  const { data: txCount = 0 } = useQuery<number>(['totalTx30Days'], { enabled: false })
  const { data: addressCount = 0 } = useQuery<number>(['addressCount30Days'], { enabled: false })
  const { isMobile, isSm, isMd } = useMatchBreakpoints()

  return (
    <Flex justifyContent="center" alignItems="center" flexDirection="column" overflow="hidden">
      <Text textAlign="center" lineHeight="110%" fontWeight={600} mb="4px" fontSize={isMobile ? '18px' : '32px'}>
        {t('MacSwap at a Glance')}
      </Text>
      <Text
        textAlign="center"
        lineHeight="110%"
        fontWeight={600}
        fontSize={isMobile ? '18px' : '32px'}
        mb={isMobile ? '24px' : '48px'}
        color="secondary"
      >
        {t('Growing Every Day')}
      </Text>
      <Flex
        justifyContent="center"
        alignItems="center"
        flexDirection={isMobile ? 'column' : 'row'}
        width={['100%', '100%', '100%', '800px']}
        style={{ gap: isMobile ? 16 : 50 }}
        mb={isMobile ? '24px' : '48px'}
        flexWrap="wrap"
      >
        <MetricsCard
          width={isSm || isMd ? '100%' : 'auto'}
          title={t('Total Users:')}
          value={addressCount}
          description={t('in the last 30 days')}
        />
        <MetricsCard title={t('Total Trades:')} value={txCount} description={t('in the last 30 days')} />
        <MetricsCard title={t('Total Value Locked:')} value={tvl} description={t('in the last 30 days')} prefix="$" />
      </Flex>
      <ChainTags />
    </Flex>
  )
}

export default Stats
